import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class AppServicesWaldenBoxIndexRoute extends Route {
  @service('router') declare router: RouterService;

  beforeModel() {
    this.router.transitionTo('app.services.walden-box.list');
  }
}
